import React, { useContext, useState } from "react";
import AdvisorNavbar from "../layout/AdvisorNavbar";
import LocContext from "../context/locContext";
import { useNavigate } from "react-router-dom";
import { FiUserPlus, FiMail, FiPhone, FiFileText, FiSend, FiCheckCircle, FiClock, FiAlertCircle } from "react-icons/fi";
import Swal from "sweetalert2";
import { NavLink } from "react-router-dom";

export default function OnboardClient() {
  const { userData } = useContext(LocContext);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    pan: "",
    consent: false,
  });

  const [onboardingSteps] = useState([
    { id: 1, title: "Lead Created", status: "completed", date: "2024-01-15" },
    { id: 2, title: "Invite Sent", status: "completed", date: "2024-01-15" },
    { id: 3, title: "Client Registered", status: "pending", date: null },
    { id: 4, title: "KYC Initiated", status: "pending", date: null },
    { id: 5, title: "Onboarding Complete", status: "pending", date: null },
  ]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleCreateLead = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.firstName || !formData.lastName || !formData.email || !formData.phone) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please fill in all required fields",
        customClass: {
          popup: "custom-swal-popup",
        },
      });
      return;
    }

    if (!formData.consent) {
      Swal.fire({
        icon: "error",
        title: "Consent Required",
        text: "Please provide consent to proceed",
        customClass: {
          popup: "custom-swal-popup",
        },
      });
      return;
    }

    // Simulate API call
    Swal.fire({
      title: "Creating Lead...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    setTimeout(() => {
      Swal.fire({
        icon: "success",
        title: "Lead Created Successfully!",
        text: "Invitation email has been sent to the client.",
        showConfirmButton: true,
        customClass: {
          popup: "custom-swal-popup",
        },
      });
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        pan: "",
        consent: false,
      });
    }, 1500);
  };

  const handleResendInvite = (email) => {
    Swal.fire({
      icon: "success",
      title: "Invite Resent",
      text: `Invitation email has been resent to ${email}`,
      customClass: {
        popup: "custom-swal-popup",
      },
    });
  };

  return (
    <>
    <AdvisorNavbar />
    <div className="page-content" style={{ background: "#f1f5f9" }}>
   
          {/* Header */}
          <div className="card shadow-sm p-4 mb-4" style={{ borderRadius: "12px" }}>
            {/* <div style={{
              background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
              padding: "20px",
              borderRadius: "12px",
              borderBottom: "3px solid #39b2b4",
            }}> */}
              <div className="d-flex align-items-center">
                
                <div>
                  <h2 className="mb-1" >
                    Onboard Client
                  </h2>
                  <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/agent/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Onboard Client
                  </li>
                </ol>
              </nav>
              
                </div>
              {/* </div> */}
            </div>
          </div>

          <div className="row g-4">
            {/* Lead Form */}
            <div className="col-12 col-lg-7">
              <div className="card shadow-sm" style={{ borderRadius: "12px", border: "none" }}>
                <div className="card-body p-4">
                  <div style={{
                    background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
                    padding: "16px",
                    borderRadius: "12px",
                    borderBottom: "3px solid #39b2b4",
                    marginBottom: "24px",
                  }}>
                    <h4 className="mb-0" >
                      Create Client Lead
                    </h4>
                  </div>

                  <form onSubmit={handleCreateLead}>
                    <div className="row g-3">
                      <div className="col-12 col-md-6">
                        <label className="form-label" style={{ color: "#1e293b", fontWeight: "500", fontSize: "14px" }}>
                          First Name <span style={{ color: "#ef4444" }}>*</span>
                        </label>
                        <div className="position-relative">
                          <FiUserPlus style={{
                            position: "absolute",
                            left: "12px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#64748b",
                            fontSize: "18px",
                          }} />
                          <input
                            type="text"
                            className="form-control"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleInputChange}
                            placeholder="Enter first name"
                            style={{
                              paddingLeft: "40px",
                              borderRadius: "8px",
                              border: "2px solid #e2e8f0",
                              fontSize: "14px",
                            }}
                            required
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-6">
                        <label className="form-label" style={{ color: "#1e293b", fontWeight: "500", fontSize: "14px" }}>
                          Last Name <span style={{ color: "#ef4444" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="lastName"
                          value={formData.lastName}
                          onChange={handleInputChange}
                          placeholder="Enter last name"
                          style={{
                            borderRadius: "8px",
                            border: "2px solid #e2e8f0",
                            fontSize: "14px",
                          }}
                          required
                        />
                      </div>

                      <div className="col-12 col-md-6">
                        <label className="form-label" style={{ color: "#1e293b", fontWeight: "500", fontSize: "14px" }}>
                          Email Address <span style={{ color: "#ef4444" }}>*</span>
                        </label>
                        <div className="position-relative">
                          <FiMail style={{
                            position: "absolute",
                            left: "12px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#64748b",
                            fontSize: "18px",
                          }} />
                          <input
                            type="email"
                            className="form-control"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            placeholder="Enter email address"
                            style={{
                              paddingLeft: "40px",
                              borderRadius: "8px",
                              border: "2px solid #e2e8f0",
                              fontSize: "14px",
                            }}
                            required
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-6">
                        <label className="form-label" style={{ color: "#1e293b", fontWeight: "500", fontSize: "14px" }}>
                          Phone Number <span style={{ color: "#ef4444" }}>*</span>
                        </label>
                        <div className="position-relative">
                          <FiPhone style={{
                            position: "absolute",
                            left: "12px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#64748b",
                            fontSize: "18px",
                          }} />
                          <input
                            type="tel"
                            className="form-control"
                            name="phone"
                            value={formData.phone}
                            onChange={handleInputChange}
                            placeholder="Enter phone number"
                            style={{
                              paddingLeft: "40px",
                              borderRadius: "8px",
                              border: "2px solid #e2e8f0",
                              fontSize: "14px",
                            }}
                            required
                          />
                        </div>
                      </div>

                      <div className="col-12">
                        <label className="form-label" style={{ color: "#1e293b", fontWeight: "500", fontSize: "14px" }}>
                          PAN Number (Optional)
                        </label>
                        <div className="position-relative">
                          <FiFileText style={{
                            position: "absolute",
                            left: "12px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#64748b",
                            fontSize: "18px",
                          }} />
                          <input
                            type="text"
                            className="form-control"
                            name="pan"
                            value={formData.pan}
                            onChange={handleInputChange}
                            placeholder="Enter PAN number"
                            style={{
                              paddingLeft: "40px",
                              borderRadius: "8px",
                              border: "2px solid #e2e8f0",
                              fontSize: "14px",
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="consent"
                            id="consent"
                            checked={formData.consent}
                            onChange={handleInputChange}
                            style={{
                              borderRadius: "4px",
                              border: "2px solid #e2e8f0",
                            }}
                            required
                          />
                          <label className="form-check-label" htmlFor="consent" style={{ color: "#64748b", fontSize: "14px" }}>
                            I have obtained consent from the client to share their information and send invitation.
                          </label>
                        </div>
                      </div>

                      <div className="col-12">
                        <button
                          type="submit"
                          className="btn btn-primary "
                          style={{
                            // background: "linear-gradient(135deg, #1bafb4 0%, #39b2b4 100%)",
                            color: "#ffffff",
                            border: "none",
                            borderRadius: "8px",
                            padding: "12px 24px",
                            fontWeight: "500",
                            fontSize: "16px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "8px",
                          }}
                        >
                          <FiSend style={{ fontSize: "18px" }} />
                          Create Lead & Send Invite
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            {/* Onboarding Tracker */}
            <div className="col-12 col-lg-5">
              <div className="card shadow-sm" style={{ borderRadius: "12px", border: "none" }}>
                <div className="card-body p-4">
                  <div style={{
                    background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
                    padding: "16px",
                    borderRadius: "12px",
                    borderBottom: "3px solid #39b2b4",
                    marginBottom: "24px",
                  }}>
                    <h4 className="mb-0" >
                      Onboarding Steps
                    </h4>
                  </div>

                  <div className="d-flex flex-column gap-3">
                    {onboardingSteps.map((step, index) => (
                      <div key={step.id} className="d-flex align-items-start">
                        <div style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          background: step.status === "completed"
                            ? "linear-gradient(135deg, #10b981 0%, #059669 100%)"
                            : step.status === "pending"
                            ? "#e2e8f0"
                            : "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "12px",
                          flexShrink: 0,
                        }}>
                          {step.status === "completed" ? (
                            <FiCheckCircle style={{ color: "#ffffff", fontSize: "18px" }} />
                          ) : step.status === "pending" ? (
                            <FiClock style={{ color: "#64748b", fontSize: "18px" }} />
                          ) : (
                            <FiAlertCircle style={{ color: "#ffffff", fontSize: "18px" }} />
                          )}
                        </div>
                        <div style={{ flex: 1 }}>
                          <h6 className="mb-1" style={{
                            color: step.status === "completed" ? "#10b981" : "#1e293b",
                            fontSize: "14px",
                            fontWeight: "600",
                          }}>
                            {step.title}
                          </h6>
                          {step.date && (
                            <p className="mb-0" style={{ color: "#64748b", fontSize: "12px" }}>
                              {new Date(step.date).toLocaleDateString()}
                            </p>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </>
  );
}
